import React, { useEffect, useState } from "react";
import hrApi from "./hrApi";
import { hrOpen } from "./HrCompliance";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { FileCheck2, Upload, Eye, PenLine } from "lucide-react";

function Signatory() {
  const [f, setF] = useState({ name: "", title: "" });
  useEffect(() => { hrApi.get("/pdf-signatory").then((r) => setF(r.data)); }, []);
  const save = async () => { await hrApi.put("/pdf-signatory", f); toast.success("Company signatory saved"); };
  return (
    <div className="p-4 border-b border-slate-100 space-y-2" data-testid="pdf-signatory">
      <div className="text-sm font-semibold text-slate-700 inline-flex items-center gap-1.5"><PenLine size={14} className="text-indigo-500" /> Company signatory (auto-stamped on “EXECUTED by G &amp; L One” and “Signature of Manager”)</div>
      <div className="flex flex-wrap gap-2">
        <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Full name" className="h-9 w-56" data-testid="pdf-signatory-name" />
        <Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Title, e.g. HR Manager" className="h-9 w-56" data-testid="pdf-signatory-title" />
        <Button onClick={save} className="h-9 rounded-full bg-indigo-500 text-white" data-testid="pdf-signatory-save">Save</Button>
      </div>
      {!f.name && <p className="text-xs text-amber-700">Not set — company signature blocks stay blank until you add a name.</p>}
    </div>
  );
}

function Row({ t, reload }) {
  const up = async (file) => {
    if (!file) return; const fd = new FormData(); fd.append("file", file);
    try { const { data } = await hrApi.post(`/templates/${t.id}/master-pdf`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success(`PDF attached (${data.pages} pages)`); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
  };
  const has = t.master_file || t.master_upload_path;
  return (
    <div className="px-4 py-3 flex flex-wrap items-center gap-2" data-testid={`pdf-tpl-${t.id}`}>
      <div className="flex-1 min-w-[200px]"><div className="text-sm font-semibold text-slate-800">{t.name}</div><div className="text-xs text-slate-500 capitalize">{t.kind}</div></div>
      <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full ${has ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`} data-testid={`pdf-tpl-status-${t.id}`}>{has ? "Exact PDF" : "Text form (old)"}</span>
      {has && <button onClick={() => hrOpen(`/templates/${t.id}/master-pdf`)} className="text-xs text-indigo-600 inline-flex items-center gap-1" data-testid={`pdf-tpl-view-${t.id}`}><Eye size={13} /> View</button>}
      <label className="text-xs text-indigo-600 inline-flex items-center gap-1 cursor-pointer"><Upload size={13} /> {has ? "Replace PDF" : "Upload PDF"}
        <input type="file" accept="application/pdf" className="hidden" data-testid={`pdf-tpl-upload-${t.id}`} onChange={(e) => { up(e.target.files?.[0]); e.target.value = ""; }} /></label>
    </div>
  );
}

export default function PdfTemplates() {
  const [rows, setRows] = useState([]);
  const load = () => hrApi.get("/templates").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm" data-testid="pdf-templates">
      <div className="p-4 border-b border-slate-100"><h3 className="font-heading font-bold text-slate-800 inline-flex items-center gap-2"><FileCheck2 size={16} className="text-indigo-500" /> Contract &amp; induction PDFs</h3>
        <p className="text-xs text-slate-500">Workers see and sign the exact PDF with their name filled in at [FULL NAME] / [Insert Name] / [INSERT EMPLOYEE NAME]; contracts also get Schedule 1 start date and position from the profile. New templates: upload a PDF (Word → Save as PDF).</p></div>
      <Signatory />
      <div className="divide-y divide-slate-50">{rows.map((t) => <Row key={t.id} t={t} reload={load} />)}</div>
    </div>
  );
}
